












































































































/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import * as routeNames from '../router-names';

import moment from 'moment';

import { queryParkingRecordDetail } from '../../../api/order-management';
import ParkingReviewImage from '../../../components/parking-review-image/index.vue';
import { API_SERVER } from '@/common/config';
import GoBackWithCloseTab from '@/common/mixins/go-back-with-close-tab';
import ShowImg from '@/components/show-img/index.vue';
@Component({
  components: {
    ParkingReviewImage,
    ShowImg
  },
  filters: {
    accountingRulesFillter(typeVal: string) {
      let type = '';
      switch (typeVal) {
        case '超时':
          type = '';
          break;
        case '超区':
          type = 'danger';
          break;
        case '超位':
          type = 'primary';
          break;
      }
      return type;
    }
  }
})
export default class ParkingRecordDetail extends Mixins(GoBackWithCloseTab) {
  beforeRouteLeave(to: any, from: any, next: () => void) {
    next(); // 必须调用 // next(true)进入原计划的下个页面 // next(false)进入from页面(即原本的页面)
  }
  navs = [
    {
      label: '停车记录',
      location: {
        name: routeNames.PARKING_RECORD_LIST
      }
    },
    {
      label: '停车记录详情'
    }
  ];
  private imgBaseUrl = `${API_SERVER.imgBaseUrl}`;
  private defaultImg = `${API_SERVER.defaultImg}`;
  private detailModel = {};
  private parkId = '';
  private pkOrderId = '';
  activated() {
    console.log('activated');
    this.init();
    if (this.pkOrderId) {
      this.queryParkingRecord();
    }
  }
  created() {
    console.log('created');
    if (!(this.$route.params && this.$route.params.from)) {
      this.init();
      if (this.pkOrderId) {
        this.queryParkingRecord();
      }
    }
  }
  private init() {
    this.parkId = (this.$route.params.parkId as string) || (this.$route.query.parkId as string);
    this.pkOrderId = (this.$route.params.pkOrderId as string) || (this.$route.query.pkOrderId as string);
  }
  private async queryParkingRecord() {
    this.detailModel = {};
    try {
      const { status, msg, code, data = {} } = await queryParkingRecordDetail({
        parkId: this.parkId,
        pkOrderId: this.pkOrderId
      });
      if (status !== '9999') {
        this.$message.error(msg);
      }
      if (data) {
        this.detailModel = data;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryOrderEnterDetail,出现错误', error);
    }
  }

  enterDetail = [
    {
      prop: 'enterChannelName',
      label: '入场通道:'
    },
    {
      prop: 'enterDutyOfficer',
      label: '入场操作员:'
    },
    {
      prop: 'pkOrderId',
      label: '停车订单号:',
      render(h: any, params: any) {
        const { pkOrderId = '' } = params.data;
        return h(
          'a-tooltip',
          {
            attrs: {
              placement: 'topLeft',
              title: pkOrderId
            }
          },
          [
            h(
              'div',
              {
                class: 'text-ellipse',
                attrs: {
                  style: 'width:120px'
                }
              },
              pkOrderId || '-'
            )
          ]
        );
      }
    },
    {
      prop: 'parkingTime',
      label: '停车总时长:'
    }
    // {
    //   prop: 'remark',
    //   label: '备注',
    // },
  ];
  exitDetail = [
    {
      prop: 'exitChannelName',
      label: '出场通道:'
    },
    {
      prop: 'exitDutyOfficer',
      label: '出场操作员:'
    },
    {
      prop: 'exitTime',
      label: '出场时间:'
    },
    {
      prop: 'totalAmount',
      label: '总应收:',
      render(h: any, params: any) {
        let { totalAmount = 0, feeTypeName = '' } = params.data;
        if (!feeTypeName) {
          feeTypeName = [];
        } else {
          feeTypeName = feeTypeName.split(',');
        }
        return h('div', [
          h('span', ((+totalAmount).toFixed(2) || '0.00') + '元')
          // 本期隐藏
          // feeTypeName.length === 0
          //   ? ''
          //   : feeTypeName.map((item: any, index: number) => {
          //       let type = '';
          //       switch (item) {
          //         case '超时':
          //           type = '';
          //           break;
          //         case '超区':
          //           type = 'danger';
          //           break;
          //         case '超位':
          //           type = 'primary';
          //           break;
          //       }
          //       return h('a-button', {
          //         style: {
          //           marginLeft: '8px'
          //         },
          //         attrs: {
          //           type,
          //           size: 'small'
          //         },
          //         domProps: {
          //           innerHTML: item
          //         }
          //       });
          //     })
        ]);
      }
    },
    {
      prop: 'paidAmount',
      label: '总实收:',
      render(h: any, params: any) {
        const { paidAmount } = params.data;
        return h('div', ((+paidAmount).toFixed(2) || '0.00') + '元');
      }
    },
    {
      prop: 'discountAmount',
      label: '总优惠:',
      render(h: any, params: any) {
        const { discountAmount } = params.data;
        return h('div', ((+discountAmount).toFixed(2) || '0.00') + '元');
      }
    },
    {
      prop: 'releaseCause',
      label: '备注:'
    }
  ];
  infoFields = [
    {
      prop: 'enterTime',
      label: '进场时间:'
    },
    {
      prop: 'authTypeName',
      label: '车辆类型:'
    },
    {
      prop: 'authorizDate',
      label: '授权期限:'
    },
    {
      prop: 'userName',
      label: '姓名:'
    },
    {
      prop: 'userTel',
      label: '联系电话:'
    },
    {
      prop: 'carType',
      label: '车型:'
    }
  ];

  tableColums = [
    {
      title: '停放区域',
      dataIndex: 'areaName'
    },
    {
      title: '授权类型',
      dataIndex: 'authTypeName'
    },
    {
      title: '行程开始时间',
      dataIndex: 'enterTime'
    },
    {
      title: '行程结束时间',
      dataIndex: 'exitTime'
    },
    {
      title: '计费原因',
      dataIndex: 'feeTypeName'
    }
    // {
    //   title: '计费类型',
    //   dataIndex: 'feeTypeName',
    //   scopedSlots: { customRender: 'feeTypeName' },
    // },
  ];

  tableColums1 = [
    // {
    //   title: '支付场景',
    //   dataIndex: 'payScenesName',
    // },
    {
      title: '支付方式',
      dataIndex: 'payMethodName'
    },
    {
      title: '支付渠道',
      dataIndex: 'payChannelName'
    },
    {
      title: '平台流水号',
      dataIndex: 'localOrderId'
    },
    {
      title: '第三方交易流水号',
      dataIndex: 'thirdTradeNo'
    },
    {
      title: '交易时间',
      dataIndex: 'paidTime'
    },
    {
      title: '应收金额',
      dataIndex: 'totalAmount'
    },
    {
      title: '实收金额',
      dataIndex: 'paidAmount'
    },
    {
      title: '优惠金额',
      dataIndex: 'discountAmount'
    },
    {
      title: '应收未收',
      dataIndex: 'unpaidAmount'
    },
    {
      title: '减免金额',
      dataIndex: 'cancelAmount'
    }
    // {
    //   title: '交易金额',
    //   dataIndex: 'paidAmount',
    //   customRender: (text: any, record: any, index: number) =>
    //     Number(text || 0).toFixed(2) ? `${Number(text || 0).toFixed(2)}元` : '--'
    // }
  ];
  tripRealRecordsTableColums = [
    {
      title: '区域',
      dataIndex: 'areaName'
    },
    {
      title: '通道',
      dataIndex: 'channelName'
    },
    {
      title: '进出场类型',
      dataIndex: 'typeName'
    },
    {
      title: '通行时间',
      dataIndex: 'time'
    },
    {
      title: '查看图片',
      dataIndex: 'img',
      scopedSlots: { customRender: 'img' }
    }
  ];
  showReviewImgModel = false;
  reviewModelDate = { typeName: '' };
  get reviewColums() {
    return [
      {
        imageSrc: 'img',
        data: [
          {
            label: `${this.reviewModelDate.typeName}时间`,
            dataIndex: 'time'
          },
          {
            label: `${this.reviewModelDate.typeName}通道`,
            dataIndex: 'channelName'
          }
        ]
      }
    ];
  }
  showImg(obj: any) {
    this.showReviewImgModel = true;
    this.reviewModelDate = obj;
  }
  getEnterImg() {
    window.open((this.$refs.enterImg as any).src);
  }
  getExitImg() {
    window.open((this.$refs.exitImg as any).src);
  }
}
